module.exports = __webpack_public_path__ + "static/img/gnld_3@2x.62902121.png";